import { create } from 'zustand'

type ContactPanelState = {
  isOpen: boolean
  open: () => void
  close: () => void
}

/**
 * Ouverture du formulaire « Besoin d'aide » (#81) depuis n'importe où — menus
 * utilisateur, centre d'aide — alors qu'il n'est monté qu'une fois (`Root`).
 */
export const useContactPanel = create<ContactPanelState>()(set => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}))
